import './scss/main.scss';

const dealersByDistrict = {
  'A CORUÑA': [
    { code: 'XE00050001', designation: 'Caetano X S.L.U.', municipality: 'A CORUÑA' }
  ],
  ALICANTE: [
    { code: 'XE06080011', designation: 'Grupo Huertas Alicante', municipality: 'ALICANTE' }
  ],
  'ALMERÍA': [
    { code: 'XE00090003', designation: 'Xpeng Indalo Almería', municipality: 'HUÉRCAL DE ALMERÍA' }
  ],
  ASTURIAS: [
    { code: 'XE00030002', designation: 'Blendio Estauto S.L.U', municipality: 'OVIEDO' }
  ],
  BALEARES: [
    { code: 'XE00040008', designation: 'Proa Group', municipality: 'PALMA DE MALLORCA' }
  ],
  BARCELONA: [
    { code: 'XE00040006', designation: 'Catay Premium S.L.', municipality: 'BARCELONA' },
    { code: 'XE00060001', designation: 'Xpeng Movento', municipality: 'SABADELL' },
    { code: 'XE00200002', designation: 'XPENG Full Traction', municipality: 'MANRESA' }
  ],
  CANTABRIA: [
    { code: 'XE00030001', designation: 'Blendio Estauto S.L.U', municipality: 'SANTANDER' }
  ],
  GIRONA: [
    { code: 'XE00180002', designation: 'Xpeng Texauto', municipality: 'GIRONA' }
  ],
  GIPUZKOA: [
    { code: 'XE00140001', designation: 'Xpeng Grupo Gorla', municipality: 'LASARTE' }
  ],
  GRANADA: [
    { code: 'XE00150001', designation: 'XPENG Overland', municipality: 'GRANADA' }
  ],
  'LAS PALMAS': [
    { code: 'XE00780002', designation: 'Xpeng Pelican Motor Gran Canarias', municipality: 'LAS PALMAS DE GRAN CANARIA' }
  ],
  LLEIDA: [
    { code: 'XE00200003', designation: 'XPENG Auto 3000', municipality: 'LLEIDA' }
  ],
  MADRID: [
    { code: 'XE00020002', designation: 'Caetano MP S.L.U.', municipality: 'MADRID' },
    { code: 'XE06080010', designation: 'Caetano X S.L.U.', municipality: 'MAJADAHONDA' },
    { code: 'XE00160026', designation: 'Xpeng Chinares', municipality: 'ALCALÁ DE HENARES' },
    { code: 'XE00110003', designation: 'XPENG Grupo Cars', municipality: 'LEGANÉS' }
  ],
  'MÁLAGA': [
    { code: 'XE00040003', designation: 'Caetano X S.L.U.', municipality: 'MÁLAGA' }
  ],
  MURCIA: [
    { code: 'XE00080002', designation: 'XPENG Huertas Import, S.L.', municipality: 'MURCIA' }
  ],
  NAVARRA: [
    { code: 'XE00150002', designation: 'Xpeng Torregrosa', municipality: 'NOÁIN' }
  ],
  PONTEVEDRA: [
    { code: 'XE00250018', designation: 'XPENG P. Rumbao', municipality: 'VIGO' }
  ],
  'SANTA CRUZ DE TENERIFE': [
    { code: 'XE00090001', designation: 'Xpeng Pelican Motor Tenerife', municipality: 'SANTA CRUZ DE TENERIFE' }
  ],
  SEVILLA: [
    { code: 'XE00040004', designation: 'XPENG Caetano X S.L.U.', municipality: 'SEVILLA' }
  ],
  TARRAGONA: [
    { code: 'XE00140002', designation: 'Xpeng Nima', municipality: 'REUS' }
  ],
  VALENCIA: [
    { code: 'XE00160027', designation: 'Xpeng Grupo Moll', municipality: 'GANDIA' },
    { code: 'XE06980005', designation: 'Xpeng Moll Valencia', municipality: 'BENICALAP' }
  ],
  VALLADOLID: [
    { code: 'XE06010011', designation: 'Autocyl S.L.', municipality: 'VALLADOLID' }
  ],
  VIZCAYA: [
    { code: 'XE06080009', designation: 'Blendio Estauto S.L.U', municipality: 'GALDAKAO' }
  ],
  ZARAGOZA: [
    { code: 'XE06080012', designation: 'Grupo Agreda Zaragoza', municipality: 'ZARAGOZA' }
  ]
};

const districtSelect = document.querySelector('select[name="district"]');
const dealershipSelect = document.querySelector('select[name="dealership_code"]');
const dealershipHint = document.querySelector('.dealership-hint');
const leadForm = document.querySelector('.niw-form');
const leadContainer = document.querySelector('#get-leads');
const leadEndpoint = 'https://hooks.zapier.com/hooks/catch/3397010/2mtq665';

const scheduleLabelByValue = {
  manana: 'Mañanas',
  tarde: 'Tardes'
};

function normalizeDistrictKey(value) {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .toUpperCase();
}

const dealersByDistrictLookup = Object.fromEntries(
  Object.entries(dealersByDistrict).map(([district, dealers]) => [normalizeDistrictKey(district), dealers])
);

const requiredFieldNames = [
  'first_name',
  'last_name',
  'email',
  'phone',
  'days',
  'schedule',
  'district',
  'dealership_code',
  'privacy_policy'
];

function getFieldControl(name) {
  return leadForm?.querySelector(`[name="${name}"]`) ?? null;
}

function getFormField(name) {
  return getFieldControl(name)?.closest('.form-field') ?? null;
}

function setFieldError(name, message) {
  const formField = getFormField(name);
  if (!formField) {
    return false;
  }

  const errorNode = formField.querySelector('.form-field__error');
  formField.classList.add('has-error');

  if (errorNode) {
    errorNode.textContent = message;
    errorNode.style.display = 'block';
  }

  return false;
}

function clearFieldError(name) {
  const formField = getFormField(name);
  if (!formField) {
    return true;
  }

  const errorNode = formField.querySelector('.form-field__error');
  formField.classList.remove('has-error');

  if (errorNode) {
    errorNode.textContent = '';
    errorNode.style.display = 'none';
  }

  return true;
}

function validateField(name) {
  const control = getFieldControl(name);
  if (!control) {
    return true;
  }

  if (name === 'privacy_policy') {
    if (!control.checked) {
      return setFieldError(name, 'Debes aceptar la politica de privacidad.');
    }
    return clearFieldError(name);
  }

  const value = String(control.value ?? '').trim();

  if (!value) {
    return setFieldError(name, 'Este campo es obligatorio.');
  }

  if (name === 'first_name' || name === 'last_name') {
    if (value.length < 2) {
      return setFieldError(name, 'Introduce al menos 2 caracteres.');
    }
  }

  if (name === 'email') {
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(value);
    if (!isEmailValid) {
      return setFieldError(name, 'Introduce un email valido.');
    }
  }

  if (name === 'phone') {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 9) {
      return setFieldError(name, 'El telefono debe tener 9 digitos.');
    }
  }

  if (name === 'dealership_code') {
    if (dealershipSelect?.disabled) {
      return setFieldError(name, 'Primero selecciona una provincia.');
    }
  }

  return clearFieldError(name);
}

function validateForm() {
  let isValid = true;

  for (const fieldName of requiredFieldNames) {
    const fieldIsValid = validateField(fieldName);
    if (!fieldIsValid) {
      isValid = false;
    }
  }

  return isValid;
}

function resetDealershipOptions() {
  if (!dealershipSelect) {
    return;
  }

  dealershipSelect.innerHTML = '<option disabled selected value="">Concesionario *</option>';
  dealershipSelect.disabled = true;
}

function fillDealershipOptions(district) {
  if (!dealershipSelect) {
    return;
  }

  const districtKey = normalizeDistrictKey(district);
  const dealers = dealersByDistrictLookup[districtKey] ?? [];
  resetDealershipOptions();

  if (!dealers.length) {
    return;
  }

  const optionsMarkup = dealers
    .map((dealer) => {
      const label = `${dealer.designation} - ${dealer.municipality}`;
      return `<option value="${dealer.code}">${label}</option>`;
    })
    .join('');

  dealershipSelect.insertAdjacentHTML('beforeend', optionsMarkup);
  dealershipSelect.disabled = false;
}

function toggleDealershipHint() {
  if (!dealershipHint || !districtSelect) {
    return;
  }

  dealershipHint.style.display = districtSelect.value ? 'none' : 'block';
}

if (districtSelect && dealershipSelect) {
  districtSelect.addEventListener('change', (event) => {
    fillDealershipOptions(event.target.value);
    toggleDealershipHint();
    validateField('district');
    clearFieldError('dealership_code');
  });

  if (districtSelect.value) {
    fillDealershipOptions(districtSelect.value);
  } else {
    resetDealershipOptions();
  }
  toggleDealershipHint();
}

if (leadForm) {
  const phoneInput = getFieldControl('phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      const sanitizedValue = phoneInput.value.replace(/\D/g, '').slice(0, 9);
      if (phoneInput.value !== sanitizedValue) {
        phoneInput.value = sanitizedValue;
      }
      validateField('phone');
    });
  }

  const liveValidationFields = [
    'first_name',
    'last_name',
    'email',
    'days',
    'schedule',
    'district',
    'dealership_code',
    'privacy_policy'
  ];

  for (const fieldName of liveValidationFields) {
    const control = getFieldControl(fieldName);
    if (!control) {
      continue;
    }

    const eventName = control.type === 'checkbox' || control.tagName === 'SELECT' ? 'change' : 'input';
    control.addEventListener(eventName, () => {
      validateField(fieldName);
    });

    control.addEventListener('blur', () => {
      validateField(fieldName);
    });
  }

  leadForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const formIsValid = validateForm();
    if (!formIsValid) {
      const firstInvalidField = leadForm.querySelector('.form-field.has-error input, .form-field.has-error select, .form-field.has-error textarea');
      firstInvalidField?.focus();
      return;
    }

    const formData = new FormData(leadForm);
    void (async () => {
      const submitButton = leadForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        const daysValue = String(formData.get('days') ?? '').trim();
        const scheduleValue = String(formData.get('schedule') ?? '').trim().toLowerCase();
        const messageValue = String(formData.get('message') ?? '').trim();
        const formattedDays = daysValue
          ? `${daysValue.charAt(0).toUpperCase()}${daysValue.slice(1)}`
          : '';
        const formattedSchedule = scheduleLabelByValue[scheduleValue] ?? scheduleValue;

        const scheduleBlock = `${formattedDays} ${formattedSchedule} `;
        const mergedMessage = messageValue ? `${scheduleBlock}${messageValue}` : scheduleBlock;

        const payload = {
          First_Name: String(formData.get('first_name') ?? '').trim(),
          Last_Name: String(formData.get('last_name') ?? '').trim(),
          Email: String(formData.get('email') ?? '').trim(),
          Phone: String(formData.get('phone') ?? '').trim(),
          Postal_Code: "08015",
          District: String(formData.get('district') ?? '').trim(),
          Customer_Type: "Particular",
          Interest_In_Financing: true,
          Country_Code: "ESP",
          Country_Name: "Spain",
          Dealer_Name: "Dealer_Name",
          Dealership_Code: String(formData.get('dealership_code') ?? '').trim(),
          Dealership_Social_Media: "Dealership Social Media",
          Brand_Code: 'XPG',
          Brand_Name: "XPeng",
          Model_Code: '834',
          Model_Name: "G6",
          Message: mergedMessage,
          Privacy_Policy: formData.has('privacy_policy'),
          Consent: formData.has('marketing'),
          Form_Type: 'F16',
          Lead_Source: 'OL43',
          Lead_Type: 'TP10',
          Request_Type: 'TPD10',
          Lead_Identity: 'LI01',
          Version: "Version",
          Event_Name: "Event Name",
          Event_Date: "2026-04-10",
          Event_Time: "15:00",
          Zapier_Version: "ZV2"
        };

        const body = JSON.stringify({ data: payload });

        const response = await fetch(leadEndpoint, {
          method: 'POST',
          body
        });

        if (!response.ok) {
          const errorBody = await response.text();
          const genericError = 'No se pudo enviar el formulario. Revisa los campos e intentalo de nuevo.';
          alert(genericError);
          console.error('Error backend:', errorBody);
          return;
        }

        let result = null;
        try {
          result = await response.json();
        } catch (parseError) {
          console.error('No se pudo parsear JSON de Zapier:', parseError);
        }
        const isSuccess = result?.status === 'success';

        if (!isSuccess) {
          const genericError = 'No se pudo enviar el formulario. Revisa los campos e intentalo de nuevo.';
          alert(genericError);
          console.error('Respuesta inesperada del endpoint:', result);
          return;
        }

        console.log('Zapier POST success:', {
          payload,
          id: result?.id ?? null,
          attempt: result?.attempt ?? null,
          request_id: result?.request_id ?? null,
          status: result?.status ?? null,
          response: result
        });

        if (leadContainer) {
          leadContainer.innerHTML = `
            <div class="lead-success">
              <p class="lead-success__title">GRACIAS!</p>
              <p class="lead-success__text">Sus datos se han enviado correctamente.</p>
            </div>
          `;
        }
      } catch (error) {
        console.error('Error de red al enviar el formulario:', error);
        alert('Error de conexion. Intenta enviar de nuevo.');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    })();
  });
}



const sliderRoot = document.querySelector('[data-mouse-slider]');
const sliderTrack = document.querySelector('[data-mouse-slider-track]');
// 1. CORRECCIÓN: Tenías un typo (.inner-conatiner)
const sliderContainer = document.querySelector('.slider-container');

if (sliderRoot && sliderTrack && sliderContainer) {
  let isDragging = false;
  let startPointerX = 0;
  let startTranslateX = 0;
  let currentTranslateX = 0;
  let minTranslateX = 0;
  const isMobileSlider = () => window.matchMedia('(max-width: 767px)').matches;

  function updateBounds() {
    if (isMobileSlider()) {
      isDragging = false;
      sliderRoot.classList.remove('is-dragging');
      currentTranslateX = 0;
      minTranslateX = 0;
      sliderTrack.style.transform = 'none';
      return;
    }

    const containerRect = sliderContainer.getBoundingClientRect();

    // 2. NUEVA LÓGICA: Obtenemos la posición X real del track, restando lo que ya hayamos arrastrado
    const trackRect = sliderTrack.getBoundingClientRect();
    const untranslatedTrackLeft = trackRect.left - currentTranslateX;

    // Calculamos el espacio desde donde empieza REALMENTE el primer artículo hasta el final del contenedor
    const containerVisibleWidthFromTrackStart = Math.max(0, containerRect.right - untranslatedTrackLeft);

    const trackWidth = sliderTrack.scrollWidth;

    // El límite es el espacio visible menos el ancho total de las imágenes
    minTranslateX = Math.min(0, containerVisibleWidthFromTrackStart - trackWidth);

    // Aplicamos los límites para que si se redimensiona la pantalla, no se quede fuera
    currentTranslateX = Math.max(minTranslateX, Math.min(0, currentTranslateX));
    sliderTrack.style.transform = `translate3d(${currentTranslateX}px, 0, 0)`;
  }

  function onPointerDown(event) {
    if (isMobileSlider()) {
      return;
    }

    isDragging = true;
    sliderRoot.classList.add('is-dragging');
    startPointerX = event.clientX;
    startTranslateX = currentTranslateX;
    sliderRoot.setPointerCapture(event.pointerId);
  }

  function onPointerMove(event) {
    if (!isDragging || isMobileSlider()) return;

    const deltaX = event.clientX - startPointerX;
    const nextTranslateX = startTranslateX + deltaX;

    // Respetamos el límite máximo hacia la izquierda (minTranslateX) y hacia la derecha (0)
    currentTranslateX = Math.max(minTranslateX, Math.min(0, nextTranslateX));
    sliderTrack.style.transform = `translate3d(${currentTranslateX}px, 0, 0)`;
  }

  function onPointerUp(event) {
    if (!isDragging) return;

    isDragging = false;
    sliderRoot.classList.remove('is-dragging');
    sliderRoot.releasePointerCapture(event.pointerId);
  }

  sliderRoot.addEventListener('pointerdown', onPointerDown);
  sliderRoot.addEventListener('pointermove', onPointerMove);
  sliderRoot.addEventListener('pointerup', onPointerUp);
  sliderRoot.addEventListener('pointercancel', onPointerUp);
  window.addEventListener('resize', updateBounds);

  // 3. CONSEJO: Esperar a que las imágenes carguen
  // Si ejecutas updateBounds y las imágenes no tienen un ancho fijo en CSS, 
  // trackWidth será menor del real. Es mejor llamarlo cuando todo cargue:
  window.addEventListener('load', updateBounds);
  updateBounds(); // Llamada inicial de todas formas
}
